<template>
  <div style="">
    <v-btn
      style="float: right; position: absolute; top: 15px; right: 15px; "
      round
      small
      fab
      color="primary"
      @click="showHint = !showHint"
    >
      ?
    </v-btn>
    <v-card
      id="hint"
      v-show="showHint"
      color="primary"
      elevation="2"
      outlined
      style="max-width: 85%; margin: 10px auto"
    >
      <div style="color: white; padding: 2%">
        <slot></slot>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "HelpButton",
  data() {
    return {
      showHint: false,
    };
  },
  methods: {
    resetShowHint(){
      this.showHint = false;
    }
  }
};
</script>

<style>
.hintText {
  color: white;
  padding: 32px;
  margin-bottom: 0px !important;
}
.hintText > p{
    margin-bottom: 0 !important;
    color: white;
}
</style>